import React, { useState, useEffect } from "react";
import Header from "../../components/header/Header";
import styles from "./SearchPage.module.css";
import Search from "../../components/search/Search";

function SearchPage({ role }) {
  const [showNotActiveToggle, toggleShowNotActiveToggle] = useState(false);

  // Here we specify that we don't update the page so we only get active results.
  const showNavigation = true;

  useEffect(() => {
    if (role === "admin") {
      toggleShowNotActiveToggle(true);
    }
  }, [role]);

  return (
    <div className={styles["search-page-container"]}>
      <Header showNavigation={showNavigation} />
      <div className={styles["container-search"]}>
        <Search showNotActiveToggle={showNotActiveToggle} />
      </div>
    </div>
  );
}

export default SearchPage;
